import * as React from 'react'
import { minWidthToDisplayText, textHeight } from './constants'
import { MouseEventHandler } from 'react'
import Percent from '../../helper/percent'

interface Props {
    backgroundColor: string
    color: string
    classForFrame?: string
    disableDefaultTooltips: boolean
    height: number
    isDimmed?: boolean
    label: string
    onClick: MouseEventHandler<SVGElement>
    onMouseEnter: MouseEventHandler<SVGElement>
    onMouseLeave: MouseEventHandler<SVGElement>
    onMouseMove: MouseEventHandler<SVGElement>
    tooltip?: string
    width: number
    x: number
    y: number
    isHighlighted: boolean
    percentage: number
}

const classesForRect = (classForFrame: string | undefined): string =>
    classForFrame ? `${classForFrame} flamegraph-rect` : 'flamegraph-rect'

const LabeledRect = ({
    backgroundColor,
    color,
    classForFrame,
    disableDefaultTooltips,
    height,
    isDimmed = false,
    label,
    onClick,
    onMouseEnter,
    onMouseLeave,
    onMouseMove,
    tooltip,
    width,
    x,
    y,
    isHighlighted,
    percentage,
}: Props) => (
    <g
        className="flamegraph-g"
        transform={`translate(${x},${y})`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
        data-tooltip-id="flamegraphTooltip"
        data-tooltip-content={tooltip || label}
        data-tooltip-hidden={disableDefaultTooltips}
    >
        <rect width={width} height={height} fill="white" className="flamegraph-rect" />
        <rect
            width={width}
            height={height}
            fill={backgroundColor}
            onClick={onClick}
            className={classesForRect(classForFrame)}
            style={{
                opacity: isDimmed ? 0.5 : 1,
            }}
        />
        {width >= minWidthToDisplayText && (
            <foreignObject
                width={width}
                height={height}
                className="flamegraph-foreignObject"
                style={{
                    opacity: isDimmed ? 0.75 : 1,
                    paddingLeft: x < 0 ? -x : 0,
                }}
                y={height < textHeight ? -textHeight : 0}
            >
                <div className="flamegraph-div" style={{ color }}>
                    {isHighlighted ? '› ' : ''}
                    {label}
                    {percentage ? (
                        <>
                            {' '}
                            ⋅ <Percent value={percentage} class="tw-font-weight-normal" />
                        </>
                    ) : null}
                </div>
            </foreignObject>
        )}
    </g>
)

export default LabeledRect
